import defaultLogoLight from '../assets/logo.png';
import defaultLogoDark from '../assets/logo-black.png';

export { defaultLogoLight, defaultLogoDark };

export function isAuthScreenBackgroundFilename(filename) {
  if (!filename || typeof filename !== 'string') return false;
  const f = filename.trim().toLowerCase();
  return (
    f.includes('login') ||
    f.includes('cadastro') ||
    f.includes('background') ||
    f.includes('banner') ||
    f.includes('wallpaper') ||
    f.includes('fundologin') ||
    f.includes('fundocadastro')
  );
}

export function filenameFromPublicUrl(url) {
  if (!url) return '';
  const match = String(url).match(/\/public\/([^?]+)/);
  return match ? decodeURIComponent(match[1]) : '';
}

export function isSameAssetFilename(a, b) {
  if (!a || !b) return false;
  return String(a).trim() === String(b).trim();
}

/**
 * Logo exibido no menu (tema claro). Não reutiliza imagens de fundo de login/cadastro.
 */
export function resolveCalculatedLogoLight(
  appLogoLight,
  appLogoDark,
  defaultLight = defaultLogoLight,
  defaultDark = defaultLogoDark,
  options = {}
) {
  const { loginBackgroundImage, cadastroBackgroundImage } = options;

  if (appLogoLight !== defaultLight) return appLogoLight;
  if (appLogoDark === defaultDark) return appLogoLight;

  const darkFile = filenameFromPublicUrl(appLogoDark) || String(appLogoDark || '').trim();

  if (
    isAuthScreenBackgroundFilename(darkFile) ||
    isSameAssetFilename(darkFile, loginBackgroundImage) ||
    isSameAssetFilename(darkFile, cadastroBackgroundImage)
  ) {
    return appLogoLight;
  }

  return appLogoDark;
}

export function resolveCalculatedLogoDark(
  appLogoLight,
  appLogoDark,
  defaultLight = defaultLogoLight,
  defaultDark = defaultLogoDark,
  options = {}
) {
  const { loginBackgroundImage, cadastroBackgroundImage } = options;

  if (appLogoDark !== defaultDark) return appLogoDark;
  if (appLogoLight === defaultLight) return appLogoDark;

  const lightFile = filenameFromPublicUrl(appLogoLight) || String(appLogoLight || '').trim();

  if (
    isAuthScreenBackgroundFilename(lightFile) ||
    isSameAssetFilename(lightFile, loginBackgroundImage) ||
    isSameAssetFilename(lightFile, cadastroBackgroundImage)
  ) {
    return appLogoDark;
  }

  return appLogoLight;
}
